import { envObject, loadEnv } from "./load";

export const env = (key: string, defaultValue: string | null = null) : string | null => {
  loadEnv();
  return envObject[key] ?? process.env[key] ?? defaultValue;
};
